import { publicSettingApi } from './clients';
import { ProductPolicy } from '../types';
import { accessTokenInterceptor } from '@teko/auth';

interface PoliciesRequest {
  sku: string;
  sellerId?: number;
  terminalCode?: string;
  terminalId?: number;
}

interface PoliciesResponse {
  policies: ProductPolicy[];
}

publicSettingApi.addInterceptor(accessTokenInterceptor);

export const publicService = {
  // api docs: https://apidoc.teko.vn/project-doc/approved/omni_retail/presentation_layer/public_bff/version/15d54366/paths/api-v1-get-location-options/get
  getLocationOptions: async (domain: string) => {
    const data = await publicSettingApi.get('/get-location-options', {
      params: { domain },
    });
    return data?.data?.data || [];
  },

  // api docs: https://apidoc.teko.vn/project-doc/approved/omni_retail/presentation_layer/public_bff/version/latest/operations/sale-policies
  getSalePoliciesBySku: (
    params: PoliciesRequest,
    language?: string,
  ): Promise<PoliciesResponse> => {
    return publicSettingApi
      .get('/sale-policies', {
        params: { ...params },
        headers: {
          'Accept-Language': language || '*',
        },
      })
      .then(({ data }) => Promise.resolve(data));
  },
};
